import { extendTheme } from '@chakra-ui/react';

const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1350px'
};

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-85%)',
  backgroundColor: '#EEEEEE'
};

const theme = extendTheme({
  fonts: {},
  fontSizes: {
    lg: '18px'
  },
  ...breakpoints,
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label':
              {
                ...activeLabelStyles
              },
            label: {
              lineHeight: 1.25,
              top: 0,
              left: 0,
              zIndex: 2,
              position: 'absolute',
              borderRadius: '4px',
              pointerEvents: 'none',
              m: 1,
              px: 1,
              py: 0.5,
              transformOrigin: 'left top'
            }
          }
        }
      }
    }
  }
});

export { breakpoints };
export default theme;
